export const VERSION_APP = '1.1.3';
export const ENV = {
    DEV: {
        API_BASE_URL: 'https://script.google.com/macros/s/AKfycbwWRXAMT1rlFkSR78w1GIC1RR7sRg7nVBlv-0PQosL_WulfGQW9Ktq0pn3qcduqgqq-/exec',
        LIFF_ID: '2010267661-M1CmfIpu',
    },
    PROD: {
        API_BASE_URL: 'https://script.google.com/macros/s/AKfycbwWRXAMT1rlFkSR78w1GIC1RR7sRg7nVBlv-0PQosL_WulfGQW9Ktq0pn3qcduqgqq-/exec',
        LIFF_ID: '2011466675-sQPhlN1x',
    }
}

export const CURRENT_ENV = ENV.PROD;
